// extracted by mini-css-extract-plugin
export var infoSection = "_n-1";
export var infoSectionContainer = "_n-0";
export var infoSectionTitleRow = "_n-2";
export var multiLineInfo = "_n-4";
export var strong = "_n-3";